import { createContext, useContext, useMemo, useState } from "react";
import NewTicketModal from "../components/modals/NewTicketModal";

const UiModalContext = createContext(null);

export function UiModalProvider({ children }) {
  const [isNewTicketOpen, setIsNewTicketOpen] = useState(false);
  const [newTicketDefaultDate, setNewTicketDefaultDate] = useState(null);

  const openNewTicketModal = (options = {}) => {
    const nextDate = options.defaultDate || new Date();
    setNewTicketDefaultDate(nextDate);
    setIsNewTicketOpen(true);
  };

  const closeNewTicketModal = () => {
    setIsNewTicketOpen(false);
  };

  const value = useMemo(
    () => ({
      isNewTicketOpen,
      defaultDate: newTicketDefaultDate,
      openNewTicketModal,
      closeNewTicketModal,
    }),
    [isNewTicketOpen, newTicketDefaultDate]
  );

  return (
    <UiModalContext.Provider value={value}>
      {children}
      {isNewTicketOpen ? (
        <NewTicketModal
          isOpen={isNewTicketOpen}
          onClose={closeNewTicketModal}
          defaultDate={newTicketDefaultDate || new Date()}
        />
      ) : null}
    </UiModalContext.Provider>
  );
}

export function useUiModal() {
  const context = useContext(UiModalContext);
  if (!context) {
    throw new Error("useUiModal must be used within UiModalProvider");
  }
  return context;
}
